export class FullScreenObserver {
  constructor() {
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Если элемент имеет класс `remove-on-full-screen` – удалить
              if (node.classList.contains('remove-on-full-screen')) {
                this.removeIfFullScreen(node);
              }

              // Если добавленные элементы содержат `remove-on-full-screen`
              if (typeof node.querySelectorAll !== 'undefined') {
                node.querySelectorAll('.remove-on-full-screen').forEach((el) => {
                  this.removeIfFullScreen(el);
                });
              }
            }
          });
        }
      });
    });

    this.observeDocument();
    this.observeFullScreen();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true // Наблюдаем за вложенными элементами
    });

    // Проверяем уже существующие элементы
    document.querySelectorAll('.remove-on-full-screen').forEach((el) => {
      this.removeIfFullScreen(el);
    });
  }

  observeFullScreen() {
    window.addEventListener('resize', () => this.checkAndRemove());
    document.addEventListener('fullscreenchange', () => this.checkAndRemove());
  }

  removeIfFullScreen(element) {
    if (this.isFullScreen()) {
      element.remove();
    }
  }

  checkAndRemove() {
    if (this.isFullScreen()) {
      document.querySelectorAll('.remove-on-full-screen').forEach((el) => el.remove());
    }
  }

  isFullScreen() {
    return window.matchMedia('(display-mode: fullscreen)').matches || (window.innerHeight === screen.height && window.innerWidth === screen.width) || document.fullscreenElement !== null;
  }
}
